<template>
  <!-- 在线课程质量报告 -->
  <div class="analysisReport">
    <el-button type="primary" class="export" @click="exportPdf">导出pdf</el-button>
    <div class="analysisReport_box" ref="pdfContent">
      <div class="chart_box page-box">
        <div class="header_titles">
          <span v-show="false">这是completeNum的值：{{ completeNum }}</span>
          <input id="completeNum" v-show="false" v-model="completeNum" />
          <h1>
            《{{ header.courseName }}》{{ jd == 1 ? "服务课程质量季度报告" : "课程质量报告" }}
          </h1>
          <div class="number_time">
            <div>
              <span>所属资源库：{{ header.zykName }}</span>
              <span>数据截止时间：{{ dataTime }}</span>
            </div>
            <p />
            <p />
          </div>
        </div>
        <div class="division">1. 课程基本信息</div>
        <div class="basic">
          <p>课程名称：{{ header.courseName }}</p>
          <p>所属学校名称: {{ header.schoolName }}</p>
        </div>
        <div class="division m-top150">2. 课程建设情况</div>
        <div class="chart_box">
          <h4>2.1 课程引用资源类型分布</h4>
          <p>
            课程引用资源总数为{{ getUtils_Fun(courseQuoteResource.allResourceSum) }}个，其中<span
              v-for="(item, index) in courseQuoteResource.dataList"
              :key="index"
              >{{ item.name }}{{ item.value }}个<span
                v-if="index != courseQuoteResource.dataList.length - 1"
                >；</span
              > </span
            >，具体如图1所示：
          </p>
          <div class="standards_content echartsHeight">
            <circularChart
              :refId="'courseQuoteResourceChart'"
              :datas="courseQuoteResource.dataList"
              :colorName="1"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :legendLeft="'60%'"
              :circleSize="80"
              :legendListFontSize="30"
            />
          </div>
          <div class="chart_name">图1 课程引用资源类型占比</div>
        </div>
        <div class="chart_box">
          <h4 class="m-top150">2.2 课程引用试题情况</h4>
          <p />
          <p>本课程引用试题总数为{{ getUtils_Fun(questionBank.total) }}道，建设情况如图2所示：</p>
          <div class="standards_content echartsHeight">
            <circularChart
              :refId="'courseQuoteResourceChart'"
              :datas="questionBank.dataList"
              :colorName="1"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :legendLeft="'60%'"
              :circleSize="80"
              :legendListFontSize="30"
            />
          </div>
          <div class="chart_name">图2 本课程引用试题总数</div>
        </div>
      </div>

      <div class="chart_box page-box">
        <div class="division">3. 课程应用情况</div>
        <h4>3.1 开课期数及选课情况</h4>
        <p>
          该课程开课期数为{{ application.totalPeriods }}期，选课人数{{
            getUtils_Fun(application.total)
          }}人，按选课人数排序如图3所示：
        </p>
        <div class="biaoge">
          <table
            border="1"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>序号</th>
              <th>课程名称</th>
              <th>课程负责人</th>
              <th>选课人数</th>
              <th>占比</th>
              <th>创建时间</th>
              <th>课程类型</th>
            </tr>
            <tr
              v-for="(item, index) in application.dataList"
              :key="index"
              v-show="application.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.otherValue }}</td>
              <td>{{ parseInt(item.value) }}</td>
              <td>
                {{
                  ((parseInt(item.value) / application.total) * 100).toFixed(2) > 0
                    ? ((parseInt(item.value) / application.total) * 100).toFixed(2)
                    : 0
                }}%
              </td>
              <td>{{ item.createTime ? item.createTime.substring(0, 10) : "" }}</td>
              <td>{{ item.courseType }}</td>
            </tr>
            <tr v-show="application.dataList.length == 0" class="nothing">
              <td colspan="7">无</td>
            </tr>
          </table>
        </div>
        <div class="chart_name">图3 按选课情况排名（前10名）</div>
        <h4 class="m-top150">3.2 教师应用情况</h4>
        <p>教师在本课程发布相关作业测试情况如图4所示：</p>
        <div class="standards_content echartsHeight">
          <vcolumnarChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'assignmentsChart'"
            :datas="assignments.dataList"
            :transverseData="assignments.transverseData"
            :colorList="assignments.colorList"
            :innerText="'单位：次'"
            :seriesColor="true"
            :labelShow="true"
          />
        </div>
        <div class="chart_name">图4 教师发布作业测试情况</div>
        <p class="m-top150">教师在本课程具体互动情况如图5所示：</p>
        <div style="display: flex">
          <div class="standards_content echartsHeight">
            <vcolumnarChart
              :isExportTextColor="true"
              :refId="'communicationChart'"
              :datas="communications.dataList"
              :transverseData="communications.transverseData"
              :colorList="communications.colorList"
              :innerText="'单位：次'"
              :seriesColor="true"
              :labelShow="true"
              :isShowTextColor="true"
            />
          </div>
          <div class="standards_content echartsHeight">
            <vcolumnarChart
              :isExportTextColor="true"
              :refId="'communicationChart'"
              :datas="communication.dataList"
              :transverseData="communication.transverseData"
              :colorList="communication.colorList"
              :innerText="'单位：次'"
              :seriesColor="true"
              :labelShow="true"
              :isShowTextColor="true"
            />
          </div>
        </div>
        <div class="chart_name">图5 教师互动情况</div>
      </div>

      <div class="chart_box page-box">
        <h4>3.3 学生应用情况</h4>
        <p>学生在本课程中访问各类型资源情况如图6所示：</p>
        <div class="standards_content echartsHeight">
          <tcolumnarChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'variousChart'"
            :datas="various.dataList"
            :transverseData="various.transverseData"
            :colorList="various.colorList"
            :seriesColor="true"
          />
        </div>
        <div class="chart_name">图6 学生访问资源情况</div>
        <p class="m-top150">
          在本课程中参与互动的学生数为{{ getUtils_Fun(situation.cyhdrs) }}人，具体情况如图7所示：
        </p>
        <div style="display: flex">
          <div class="standards_content echartsHeight">
            <vcolumnarChart
              :isExportTextColor="true"
              :axisLabelInterval="true"
              :refId="'situationChart'"
              :datas="situation.dataList"
              :transverseData="situation.transverseData"
              :colorList="situation.colorList"
              :innerText="'单位：次'"
              :seriesColor="true"
              :labelShow="true"
              :isShowTextColor="true"
            />
          </div>
          <div class="standards_content echartsHeight">
            <vcolumnarChart
              :isExportTextColor="true"
              :axisLabelInterval="true"
              :refId="'situationChart'"
              :datas="situations.dataList"
              :transverseData="situations.transverseData"
              :colorList="situations.colorList"
              :innerText="'单位：次'"
              :seriesColor="true"
              :labelShow="true"
              :isShowTextColor="true"
            />
          </div>
        </div>
        <div class="chart_name">图7 学生互动情况</div>
        <h4 class="m-top150">3.4 用户近一月日活情况</h4>
        <p>
          本课程近一年的总访问量是{{
            getUtils_Fun(monthlyLearning.courseResourceLog)
          }}次，访问人数为{{ getUtils_Fun(monthlyLearning.learningsCount) }}人；近一月访问量{{
            getUtils_Fun(monthlyLearning.monthLog)
          }}次，访问人数{{ getUtils_Fun(monthlyLearning.userCount) }}人，近一月日活情况如图8所示：
        </p>
        <div class="standards_content echartsHeight">
          <vcolumnarChart
            v-if="monthlyLearning.dataList.length <= 1"
            :refId="'monthlyLearningChart'"
            :datas="monthlyLearning.dataList"
            :transverseData="monthlyLearning.transverseData"
            :colorList="monthlyLearning.colorList"
            :legendList="monthlyLearning.legendList"
            :innerText="'单位：次'"
            :seriesColor="true"
            :labelShow="true"
            :seriesBarWidth="200"
            :isShowTextColor="true"
            :isExportTextColor="true"
          >
          </vcolumnarChart>
          <discountChart
            v-else
            :refId="'monthlyLearningChart'"
            :datas="monthlyLearning.dataList"
            :transverseData="monthlyLearning.transverseData"
            :colorList="monthlyLearning.colorList"
            :legendList="monthlyLearning.legendList"
            :innerText="''"
            :itemStyleLabel="monthlyLearning.dataList.length < 10 ? true : false"
            :isShowTextColor="true"
            :isExportTextColor="true"
          />
        </div>
        <div class="chart_name">图8 用户近一月日活情况</div>
      </div>

      <div class="chart_box page-box">
        <h4>3.5 课程被院校使用情况</h4>
        <p>
          本课程被共计{{ differentSchools.learningUserAve }}所院校使用，其院校选课总人数有{{
            getUtils_Fun(differentSchools.total)
          }}人，选课人数排前10的学校如图9所示：
        </p>
        <div class="standards_content echartsHeight">
          <tcolumnarChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'differentSchoolsChart'"
            :datas="differentSchools.dataList"
            :transverseData="differentSchools.transverseData"
            :colorList="differentSchools.colorList"
            :seriesColor="true"
          />
        </div>
        <div class="chart_name">图9 院校选课人数排名情况</div>
      </div>
    </div>
  </div>
</template>

<script>
import circularChart from "@/components/chart/circularChart.vue"; //引入圆形图表
import vcolumnarChart from "@/components/chart/vcolumnarChart.vue"; //引入竖向柱状图图表
import tcolumnarChart from "@/components/chart/tcolumnarChart.vue"; //引入横向柱状图图表
import discountChart from "@/components/chart/discountChart.vue"; //引入折现图图表
import pageToPDF from "@/utils/htmlToPdf.js";
export default {
  components: {
    circularChart,
    vcolumnarChart,
    tcolumnarChart,
    discountChart,
  },
  data() {
    return {
      jd: null,
      completeNum: 0,
      month: "",
      colorList: [
        "#3B85FB",
        "#FD398E",
        "#8B68F1",
        "#EE6F5E",
        "#E0D35F",
        "#5470C6",
        "#DE7E4B",
        "#DE524B",
      ], //柱状图或折线图的颜色
      courseName: "",
      header: {
        zykName: "",
        courseName: "",
        zykNum: "",
        zykStatus: "",
        cutoffTime: "",
        schoolName: "",
      },
      dataTime: "",

      // 课程建设情况
      courseQuoteResource: {
        //图1 课程引用资源
        dataList: [],
        transverseData: [],
        colorList: [],
        allResourceSum: 0,
      },
      questionBank: {
        //图2 课程题库建设情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
        total: 0,
      },

      // 开课期数及选课情况概览
      application: {
        //图3 开课期数及选课情况概览
        dataList: [],
        total: 0,
        totalPeriods: 0,
      },

      assignments: {
        //图 4 教师应用情况1
        dataList: [],
        transverseData: [],
        colorList: [],
      },
      communication: {
        //图 5 教师应用情况2
        dataList: [],
        transverseData: [],
        colorList: [],
      },
      communications: {
        //图 6 教师互动情况
        dataList: [],
        transverseData: [],
        colorList: [],
      },
      various: {
        //图 6 学生应用情况1
        dataList: [],
        courseResourceLog: "",
        transverseData: [],
        colorList: [],
      },
      situation: {
        //图 7 学生应用情况2
        dataList: [],
        transverseData: [],
        colorList: [],
        cyhdrs: 0,
      },
      situations: {
        dataList: [],
        transverseData: [],
        colorList: [],
        cyhdrs: 0,
      },
      monthlyLearning: {
        //图 8  用户月活情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
        courseResourceLog: 0,
        learningsCount: 0,
      },
      differentSchools: {
        //图 9  课程被院校使用情况
        dataList: [],
        transverseData: [],
        colorList: [],
        total: 0,
        learningUserAve: 0,
      },
      // 4.1 课程用户建设进度跟踪
      userProgress: {
        dataList: [],
        transverseData: [],
      },
      // 4.2 课程资源建设进度跟踪
      material: {
        dataList: [],
        transverseData: [],
      },
      // 4.3 课程资源建设占比进度跟踪
      materialResources: {
        dataList: [],
        transverseData: [],
      },
      loading: "", //是否导出加载中
    };
  },
  created() {
    if (this.$route.query) {
      this.jd = this.$route.query.jd;
      this.dataTime = this.$route.query.dateTime;
      if(this.dataTime == ""){
        this.dataTime = this.$route.query.dataTime;
      }
      let token = this.$route.query.token;
      sessionStorage.setItem("lrmv2token", token);
      console.log("当前用户token：" + token);
      let zykid = this.$route.query.zykid;
      this.month = this.$route.query.month;
      this.dataChange(zykid);
      this.courseName = decodeURIComponent(this.$route.query.courseName);
    }
    setTimeout(() => {
      this.getStudentTeacherReportDetailDom();

      // 课程建设情况
      this.courseQuoteResourceDom();
      this.questionBankDom();
      // 开课期数及选课情况概览
      this.applicationDom();
      this.assignmentsDom();
      this.communicationDom();
      this.communicationDoms();
      this.variousDom();
      this.situationDom();
      this.situationDoms();
      this.monthlyLearningDom();
      this.differentSchoolsDom();
      this.userProgressDom(); // 4.1 课程用户建设进度跟踪
      this.materialDom(); // 4.2 课程资源建设进度跟踪
      this.materialResourcesDom(); // 4.3 课程资源建设占比进度跟踪
    }, 2000);
  },
  methods: {
    // 导出pdf文件
    exportPdf() {
      const lableList = document.getElementsByClassName("page-box");
      let name = this.header.zykName.split("(");
      let newName = "";
      let oldName = "";
      let zykName = "";
      if (name.length > 1) {
        newName = name[0];
        oldName = name[1].replace(")", "");
        zykName = `${newName}（原专业名称：${oldName}）`;
      } else zykName = this.header.zykName;
      let pre_str = "";
      if(this.header.zykNum!=null&&this.header.zykNum!=""){
        pre_str = this.header.zykNum+"_"
      }
      pageToPDF(
        pre_str + `${zykName}_${this.header.courseName}_课程质量报告`,
        this.$refs.pdfContent,
        lableList
      );
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    },
    // 处理数据
    getUtils_Fun(num) {
      const data =
        num > 100000000
          ? `${
              (num / 100000000).toFixed(2).toString().split(".")[1] === "00"
                ? (num / 100000000).toFixed(0)
                : (num / 100000000).toFixed(2)
            }亿`
          : num > 10000
          ? `${
              (num / 10000).toFixed(2).toString().split(".")[1] === "00"
                ? (num / 10000).toFixed(0)
                : (num / 10000).toFixed(2)
            }万`
          : num;
      return data;
    },
    // 切换专业
    dataChange(e) {
      this.$axios
        .post(this.$apiurls.major_switch, e, {
          loading: false,
        })
        .then((res) => {
          if (res.data) {
            sessionStorage.setItem("zykId", e);
            this.reload();
          }
        });
    },
    reload() {
      //切换专业刷新视图层
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    // 课程教学资源和基本信息
    getStudentTeacherReportDetailDom() {
      this.$axios
        .post(this.$apiurls.report_qualityReport_getCourseQualityReportDetail, this.courseName, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.header = res.data;
          }
          this.completeNum = this.completeNum + 1;
          document.getElementById("completeNum").value = this.completeNum;
        })
        .catch(() => {
          this.completeNum = this.completeNum + 1;
          document.getElementById("completeNum").value = this.completeNum;
        });
    },

    // 图1 课程引用资源
    courseQuoteResourceDom() {
      this.$axios
        .post(
          this.$apiurls.report_qualityReport_getCourseQuoteResource,
          {
            courseName: this.courseName,
            zykid: sessionStorage.getItem("zykId"),
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.data) {
            var arrList = [];
            var total = 0;
            for (let i = 0; i < res.data.length; i++) {
              arrList.push({
                name: res.data[i].mediatype,
                value: res.data[i].num,
              });
              total += res.data[i].num;
            }
            this.courseQuoteResource.dataList = arrList;
            this.courseQuoteResource.allResourceSum = total;
          }
          this.completeNum = this.completeNum + 1;
          document.getElementById("completeNum").value = this.completeNum;
        })
        .catch(() => {
          this.completeNum = this.completeNum + 1;
          document.getElementById("completeNum").value = this.completeNum;
        });
    },

    // 图2 课程题库建设情况
    questionBankDom() {
      this.$axios
        .post(
          this.$apiurls.report_qualityReport_getCourseMonthQuestionAddNum,
          {
            courseName: this.courseName,
            zykid: sessionStorage.getItem("zykId"),
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.data) {
            let total = 0;
            var arrList = [];
            for (let i = 0; i < res.data.length; i++) {
              total += res.data[i].num;
            }
            arrList.push({
              name: "本课程引用试题总数",
              value: total,
            });
            this.questionBank.total = total;
            this.questionBank.dataList = arrList;
          }
          this.completeNum = this.completeNum + 1;
          document.getElementById("completeNum").value = this.completeNum;
        })
        .catch(() => {
          this.completeNum = this.completeNum + 1;
          document.getElementById("completeNum").value = this.completeNum;
        });
    },

    // 图3 开课期数及选课情况概览
    applicationDom() {
      this.$axios
        .post(this.$apiurls.report_qualityReport_getCourseQualityCourseNper, this.courseName, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.application.total = 0;
            this.application.totalPeriods = res.data.length;
            for (let i = 0; i < res.data.length; i++) {
              this.application.total += parseFloat(res.data[i].value);
            }
            this.application.dataList = res.data.slice(0, 10);
          }
          this.completeNum = this.completeNum + 1;
          document.getElementById("completeNum").value = this.completeNum;
        });
    },

    //图 4 教师应用情况1
    assignmentsDom() {
      this.$axios
        .post(
          this.$apiurls.report_qualityReport_getCourseWork,
          {
            courseName: this.courseName,
            zykid: sessionStorage.getItem("zykId"),
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            for (var key in res.data) {
              this.assignments.transverseData.push(key);
              this.assignments.dataList.push(res.data[key]);
            }
            this.assignments.colorList = this.colorList;
          }
          this.completeNum = this.completeNum + 1;
          document.getElementById("completeNum").value = this.completeNum;
        })
        .catch(() => {
          this.completeNum = this.completeNum + 1;
          document.getElementById("completeNum").value = this.completeNum;
        });
    },

    //图 5 教师应用情况
    communicationDoms() {
      this.$axios
        .post(
          this.$apiurls.report_qualityReport_getCourseInteraction,
          {
            courseName: this.courseName,
            zykid: sessionStorage.getItem("zykId"),
            role: 2,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.data) {
            for (var key in res.data.chart) {
              this.communications.transverseData.push(key);
              this.communications.dataList.push(res.data.chart[key]);
            }
            this.communications.transverseData;
            this.communications.dataList;
            this.communications.colorList = this.colorList;
          }
          this.completeNum = this.completeNum + 1;
          document.getElementById("completeNum").value = this.completeNum;
        })
        .catch(() => {
          this.completeNum = this.completeNum + 1;
          document.getElementById("completeNum").value = this.completeNum;
        });
    },

    communicationDom() {
      this.$axios
        .post(
          this.$apiurls.report_qualityReport_getCourseInteraction,
          {
            courseName: this.courseName,
            zykid: sessionStorage.getItem("zykId"),
            role: 3,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            for (var key in res.data.chart) {
              this.communication.transverseData.push(key);
              this.communication.dataList.push(res.data.chart[key]);
            }
            this.communication.colorList = this.colorList;
          }
          this.completeNum = this.completeNum + 1;
          document.getElementById("completeNum").value = this.completeNum;
        })
        .catch(() => {
          this.completeNum = this.completeNum + 1;
          document.getElementById("completeNum").value = this.completeNum;
        });
    },

    //图 7 学生访问资源情况
    variousDom() {
      this.$axios
        .post(
          this.$apiurls.report_qualityReport_getResourceTypeLogCountByCourseName,
          this.courseName,
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.data) {
            this.various.courseResourceLog = res.data.courseResourceLog;
            this.various.dataList = res.data.echartBaseVo.value;
            this.various.transverseData = res.data.echartBaseVo.name;
            this.various.colorList = this.colorList;
          }
          this.completeNum = this.completeNum + 1;
          document.getElementById("completeNum").value = this.completeNum;
        })
        .catch(() => {
          this.completeNum = this.completeNum + 1;
          document.getElementById("completeNum").value = this.completeNum;
        });
    },

    //图 7 学生应用情况2
    situationDom() {
      this.$axios
        .post(
          this.$apiurls.report_qualityReport_getCourseInteraction,
          {
            courseName: this.courseName,
            zykid: sessionStorage.getItem("zykId"),
            role: 4,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            for (var key in res.data.chart) {
              this.situation.transverseData.push(key);
              this.situation.dataList.push(res.data.chart[key]);
            }
            this.situation.transverseData;
            this.situation.dataList;
            this.situation.colorList = this.colorList;
            this.situation.cyhdrs = res.data.cyhdrs;
          }
          this.completeNum = this.completeNum + 1;
          document.getElementById("completeNum").value = this.completeNum;
        })
        .catch(() => {
          this.completeNum = this.completeNum + 1;
          document.getElementById("completeNum").value = this.completeNum;
        });
    },

    // 图 8 学生互动情况  学生发帖数和学生回帖数(图8 右边)
    situationDoms() {
      this.$axios
        .post(
          this.$apiurls.report_qualityReport_getCourseInteraction,
          {
            courseName: this.courseName,
            zykid: sessionStorage.getItem("zykId"),
            role: 5,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.data) {
            for (var key in res.data.chart) {
              this.situations.transverseData.push(key);
              this.situations.dataList.push(res.data.chart[key]);
            }
            this.situations.transverseData;
            this.situations.dataList;
            this.situations.colorList = this.colorList;
            this.situations.cyhdrs = res.data.cyhdrs;
          }
          this.completeNum = this.completeNum + 1;
          document.getElementById("completeNum").value = this.completeNum;
        })
        .catch(() => {
          this.completeNum = this.completeNum + 1;
          document.getElementById("completeNum").value = this.completeNum;
        });
    },

    //图 8  用户近一月日活情况
    monthlyLearningDom() {
      this.$axios
        .post(
          this.$apiurls.report_qualityReport_getDayOrMonthLive,
          {
            zykid: sessionStorage.getItem("zykId"),
            courseName: this.courseName,
            month: this.month,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.data) {
            this.monthlyLearning.dataList = res.data.value;
            this.monthlyLearning.transverseData = res.data.name;
            this.monthlyLearning.colorList = this.colorList;
            this.monthlyLearning.legendList = [];
            this.monthlyLearning.learningsCount = res.data.learningsCount
              ? res.data.learningsCount
              : 0;
            this.monthlyLearning.courseResourceLog = res.data.courseResourceLog
              ? res.data.courseResourceLog
              : 0;
            this.monthlyLearning.userCount = res.data.userCount ? res.data.userCount : 0;
            this.monthlyLearning.monthLog = res.data.monthLog ? res.data.monthLog : 0;
          }
          this.completeNum = this.completeNum + 1;
          document.getElementById("completeNum").value = this.completeNum;
        })
        .catch(() => {
          this.completeNum = this.completeNum + 1;
          document.getElementById("completeNum").value = this.completeNum;
        });
    },

    // 图 9  课程被院校使用情况
    differentSchoolsDom() {
      this.$axios
        .post(this.$apiurls.report_qualityReport_getSchoolNperSituation, this.courseName, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var num = 0;
            for (let i = 0; i < res.data.echartBaseVo.name.length; i++) {
              num += parseFloat(res.data.echartBaseVo.value[i]);
            }
            this.differentSchools.dataList = res.data.echartBaseVo.value;
            this.differentSchools.transverseData = res.data.echartBaseVo.name;
            this.differentSchools.colorList = this.colorList;
            this.differentSchools.total = num;
            this.differentSchools.learningUserAve = res.data.learningUserAve;
          }
          this.completeNum = this.completeNum + 1;
          this.$forceUpdate();
          document.getElementById("completeNum").value = this.completeNum;
        })
        .catch(() => {
          this.completeNum = this.completeNum + 1;
          document.getElementById("completeNum").value = this.completeNum;
        });
    },

    // 4.1 课程用户建设进度跟踪
    userProgressDom() {
      this.$axios
        .post(
          this.$apiurls.getConstructionProgressOfParticipatingInstitutionEcharts,
          {
            echartsType: 6,
            name: this.courseName,
            type: 2,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.code === 200) {
            this.publicHandle(res.data, this.userProgress);
          }
        });
    },

    // 4.2 课程资源建设进度跟踪
    materialDom() {
      this.$axios
        .post(
          this.$apiurls.getConstructionProgressOfParticipatingInstitutionEcharts,
          {
            echartsType: 9,
            name: this.courseName,
            type: 2,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.code === 200) {
            this.publicHandle(res.data, this.material);
          }
        });
    },

    // 4.3 课程资源建设占比进度跟踪
    materialResourcesDom() {
      this.$axios
        .post(
          this.$apiurls.getConstructionProgressOfParticipatingInstitutionEcharts,
          {
            echartsType: 10,
            name: this.courseName,
            type: 2,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.code === 200) {
            this.publicHandle(res.data, this.materialResources);
          }
        });
    },

    publicHandle(data, newobj) {
      let realValue = [];
      let targetValue = [];
      let nameList = [];
      for (let i = 0; i < data.length; i++) {
        if (!data[i].value) {
          data[i].value = {};
          data[i].value.realValue = 0;
          data[i].value.targetValue = 0;
        } else {
          if (!data[i].value.realValue) {
            data[i].value.realValue = 0;
          }
          if (!data[i].value.targetValue) {
            data[i].value.targetValue = 0;
          }
        }
        realValue.push(data[i].value.realValue);
        targetValue.push(data[i].value.targetValue);
        if (data[i].name.indexOf("占比") !== -1) data[i].name = data[i].name.replace("占比", "");
        if (data[i].name.indexOf("素材资源") !== -1)
          data[i].name = data[i].name.replace("素材资源", "");
        nameList.push(data[i].name);
      }
      newobj.dataList = [realValue, targetValue];
      newobj.transverseData = nameList;
    },
  },
};
</script>

<style scoped>
.export {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 1;
}

.analysisReport {
  width: 100%;
  background: #fff;
}

h1,
h2,
h3,
h4,
h5,
p {
  margin: 0px;
  padding: 0px;
}

.analysisReport_box {
  /* width: 70%;
  margin: 0px auto;
  height: 10960px; */
}

.header_titles {
  display: flex;
  justify-content: center;
  flex-flow: column;
  color: #000;
  text-align: center;
  position: relative;
}

.header_titles h1 {
  font-size: 45px;
  font-weight: bold;
  color: #1d244e;
}

.number_time {
  margin: 40px 0 20px 0;
}

.number_time div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #707f9d;
  font-size: 1.5625rem;
}

.number_time p {
  width: 100%;
  height: 0.0625rem;
  background: #707f9d;
  margin-top: 0.5rem;
}

.number_time p:last-child {
  opacity: 0.5;
  margin-top: 0.25rem;
}

.download {
  width: 80px;
  background: #3d8cff;
  border: 1px solid #3d8cff;
  position: absolute;
  top: 15px;
  right: 0px;
}

.division {
  position: relative;
  clear: both;
  text-align: center;
  font-weight: bold;
  font-size: 44px;
  color: #1d244e;
  margin: 35px 0 30px 0;
}

.basic {
  display: flex;
  flex-flow: column;
  text-indent: 40px;
  line-height: 50px;
  font-size: 30px;
  color: #707f9d;
}

.biaoge {
  width: 95%;
  margin: 10px auto 0px;
}

.biaoge .twoTable {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.course {
  text-align: center;
  margin: 0px 10px;
}

.course tr {
  height: 42px;
  color: #707f9d;
  font-size: 22px;
}

.course tr:nth-child(2n) {
  background: #fff;
  color: #566178;
}

.course tr:nth-child(2n-1) {
  background: #7ed2ff;
  color: #566178;
}

.course tr:first-child {
  background: #66adff;
  color: #fff;
}

.chart_box h4 {
  font-weight: 700;
  font-size: 42px;
  color: #1d244e;
  /*text-indent: 40px;*/
  line-height: 100px;
}

.chart_box p {
  font-size: 35px;
  text-indent: 2em;
  line-height: 60px;
  color: #707f9d;
}

.chart_box .echartsHeight {
  width: 80%;
  height: 28rem;
  margin: 0px auto;
}

.chart_box .chart_name {
  text-align: center;
  font-size: 30px;
  color: #707f9d;
}

.chart_box .notes {
  margin: 35px;
  line-height: 25px;
  font-size: 14px;
  color: #707f9d;
}

.creditRanking {
  display: flex;
  justify-content: space-between;
  font-size: 17px;
  text-indent: 40px;
  line-height: 28px;
  color: #707f9d;
}
</style>
<style lang="scss" scoped>
.page-box {
  // padding: 7% 0;
  // height: 2740px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  // border: 1px solid red;
  .m-top150 {
    margin-top: 150px;
  }

  .m-top100 {
    margin-top: 100px;
  }

  .biaoge {
    width: 95%;
    margin: 25px auto;

    .course {
      text-align: center;
      margin: 0px 10px;

      tr {
        height: 42px;
        color: #707f9d;
        font-size: 22px;

        &:nth-child(2n) {
          background: #fff;
          color: #566178;
        }

        &:nth-child(2n-1) {
          background: #7ed2ff;
          color: #566178;
        }
      }
    }
  }
}

.flex-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & > div {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.right {
  float: right;
  margin-right: 20px;
  font-size: 32px;
}
</style>
